import { Text, View } from '@react-pdf/renderer';

import { NanodegreeProgram, Program } from '~/features/program/models/program';
import { ProgramMetadata } from '~/features/program/models/program-metadata';
import { getPartTitleFromNanodegree } from '~/features/program/utils/get-part-title-from-program';
import { isNanodegreeProgram } from '~/features/program/utils/is-program-type';

import { createPdfStyles } from '../utils/create-pdf-styles';

import { styles as sharedStyles } from './syllabus-styles';

type SyllabusSkillsProps = {
  programMetadata: ProgramMetadata;
  program: Program;
};

const styles = createPdfStyles({
  courseTitle: {
    fontFamily: 'PolySans',
    color: 'blue.800',
    fontWeight: 500,
    fontSize: '16px',
    marginTop: '16px',
    marginBottom: '8px',
  },
  skillsText: {
    ...sharedStyles.text,
    color: '#242631',
    marginTop: '8px',
  },
});

export function SyllabusSkills({ programMetadata, program }: SyllabusSkillsProps) {
  const isNanodegree = isNanodegreeProgram(program);

  const coursesWithSkills = programMetadata.courses.filter((course) => Boolean(course.skills.length));
  if (isNanodegree && coursesWithSkills.length === 0) {
    return null;
  }

  return (
    <View style={sharedStyles.section}>
      <Text style={sharedStyles.sectionTitle}>Skills You&apos;ll Learn</Text>
      {!isNanodegree && <Text style={styles.skillsText}>{programMetadata.allSkills.join(' | ')}</Text>}
      {isNanodegree &&
        coursesWithSkills.map((course) => {
          const courseTitle = getPartTitleFromNanodegree(program as NanodegreeProgram, course.key) ?? '';
          return (
            <View key={course.key}>
              <Text style={styles.courseTitle}>{courseTitle?.trim()}</Text>
              <Text style={styles.skillsText}>{course.skills.join(' | ')}</Text>
            </View>
          );
        })}
    </View>
  );
}
